import React, { useEffect } from "react"
import { useStore } from "@nanostores/react"
import { ToastStore } from "../../app/toastStore.js"

let timeoutId

const Toast = () => {
  const toast = useStore(ToastStore)
  const status = toast?.status
  const message = toast?.message

  useEffect(() => {
    if (status && status !== "hidden") {
      timeoutId = setTimeout(() => {
        closeToast()
      }, 5000)
    }
    return () => clearTimeout(timeoutId)
  }, [status])

  const closeToast = () => {
    ToastStore.set({ status: "hidden", message: "" })
  }

  const renderIcon = () => {
    const baseClass =
      "inline-flex items-center justify-center flex-shrink-0 w-8 h-8 rounded-lg "
    if (status === "success") {
      return (
        <div className={baseClass + "text-green-700 bg-green-100"}>
          <svg
            className="w-5 h-5"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
          </svg>
        </div>
      )
    } else if (status === "error") {
      return (
        <div className={baseClass + "text-red-500 bg-red-100"}>
          <svg
            className="h-5 w-5 text-red-400"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            aria-hidden="true"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M6 18L18 6M6 6l12 12"
            ></path>
          </svg>
        </div>
      )
    } else {
      return (
        <div className={baseClass + "text-blue-800 bg-blue-100"}>
          <svg
            className="h-5 w-5"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
            />
          </svg>
        </div>
      )
    }
  }

  if (status === "hidden" || !status || !message) return null

  const fallbackMsg =
    status === "success"
      ? "Success!"
      : status === "error"
        ? "Something wrong happened. Try again later"
        : ""

  return (
    <div
      className={`fixed bottom-7 left-7 z-[999] flex items-center w-fit max-w-xs p-4 text-gray-500 bg-white rounded-lg shadow`}
      role="alert"
    >
      {renderIcon()}
      <div className="ml-3 text-sm font-normal mr-10">
        {message || fallbackMsg}
      </div>
      <button
        type="button"
        className="ml-auto -mx-1.5 -my-1.5 bg-white text-gray-400 hover:text-gray-900 rounded-lg focus:ring-2 focus:ring-gray-300 p-1.5 hover:bg-gray-100 inline-flex items-center justify-center h-8 w-8"
        aria-label="Close"
        onClick={closeToast}
      >
        <span className="sr-only">Close</span>
        <svg
          className="w-3 h-3"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 14 14"
        >
          <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
          />
        </svg>
      </button>
    </div>
  )
}

export default Toast
